import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useRadioGroup } from '@mui/material';

import { ExecutionStatusEnum, type Id } from '@e-socna/data-layer';

import { AlertMessages } from '../../components/AlertMessages';

import type { FolderBusinessEntityStateForm_ActionPermission } from './fragments/action-permission.fragment';

interface Props {
  readonly actionDescription: string;
  readonly actionId: Id;
  readonly actionLabel: string;
  readonly actionPermission: FolderBusinessEntityStateForm_ActionPermission;
}

export const WorkflowActionRadio = ({
  actionDescription,
  actionId,
  actionLabel,
  actionPermission,
}: Readonly<Props>) => {
  const authorized = actionPermission.status === ExecutionStatusEnum.Ok;

  const radioGroup = useRadioGroup();
  const checked = !!radioGroup && radioGroup.value === actionId;

  return (
    <Paper sx={{ p: 2, my: 2 }}>
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <Box>
          <Radio
            checked={checked}
            disabled={!authorized}
            id={actionId}
            slotProps={{ input: { 'aria-label': actionLabel } }}
            value={actionId}
          />
        </Box>
        <Box sx={{ opacity: authorized ? 1 : 0.4 }}>
          <Typography variant="button">{actionLabel}</Typography>
          <Typography variant="subtitle1">{actionDescription}</Typography>
        </Box>
      </Stack>
      <AlertMessages
        messages={actionPermission.details.map((details) => details.fr)}
        severity={authorized ? 'success' : 'error'}
        title={authorized ? 'Action possible' : 'Action impossible'}
      />
    </Paper>
  );
};
